import React from 'react'
import "../../../Assets/css/fredrique.css"
import { isMobile } from 'react-device-detect'
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import DeskBanner from "../../../Assets/images/watches/fred/fred-banner.png"
import MobileBanner from "../../../Assets/images/watches/fred/fred-mobile.png"

import { Link } from "react-router-dom";
import img1 from '../../../Assets/images/watches/fred/item1.png'
import img2 from '../../../Assets/images/watches/fred/item2.png'
import img3 from '../../../Assets/images/watches/fred/item3.png'
import HamiBanner from "../../../Assets/images/watches/fred/fred-end-banner.png"
import WatchImg from "../../../Assets/images/watches/fred/img-box.png"
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function FrederiqueConstant() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        accessibility: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
        ]
    };
    return (
        <>
            <section className='fred_banner'>
                <div className="fred-watches-banner-section"
                    style={{
                        backgroundImage: `url(${isMobile ? MobileBanner : DeskBanner})`,
                    }}>
                    <div className="fred-watches-banner-overlay">
                        <Container>
                            <Row>
                                <Col lg={12} xs={12} className="m-auto">
                                    <div className="text-center fred-watches-banner-content">
                                        <h2 className="fred-watches-banner-title">Timeless Swiss Luxury</h2>
                                        <p className="fred-watches-banner-subtitle">
                                            Discover the elegance of Frédérique Constant watches, where classic Swiss craftsmanship meets modern innovation. Each timepiece is designed with precision, luxury, and timeless style for those who value true sophistication.
                                        </p>
                                        <Button
                                            as={Link}
                                            to="/watches-list/Frederique%20Constant" variant="light" className="fred-watches-banner-btn">
                                            Shop Now
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </section>

            <section className='novelties_section_fred'>
                {/* Novelties Section */}
                <Container className="watches_container_fred">
                    <Row className="g-4 justify-content-center">
                        <Col xs={12}>
                            {isMobile ? (
                                <Slider {...settings}>
                                    {[
                                        { name: "Manufacture", desc: "Classic Perpetual Calendar", ImgUrl: img1 },
                                        { name: "Manufacture", desc: "Manufacture", ImgUrl: img2 },
                                        { name: "Classics", desc: "Premiere", ImgUrl: img3 },
                                    ].map((item, index) => (
                                        <div key={index} className="h-100 text-center product_item_fred">
                                            <Card.Img variant="top" src={item.ImgUrl} alt={item.name} />
                                            <Card.Body>
                                                <Card.Title>{item.name}</Card.Title>
                                                <p>{item.desc}</p>
                                                <Button
                                                    variant="outline"
                                                    size="sm"
                                                    as={Link}
                                                    to="/watches-list/Frederique%20Constant"
                                                >
                                                    Explore Now
                                                </Button>
                                            </Card.Body>
                                        </div>
                                    ))}
                                </Slider>
                            ) :
                                (
                                    <Row className="g-4 justify-content-center">
                                        {[
                                            { name: "Manufacture", desc: "Classic Perpetual Calendar", ImgUrl: img1 },
                                            { name: "Manufacture", desc: "Manufacture", ImgUrl: img2 },
                                            { name: "Classics", desc: "Premiere", ImgUrl: img3 },
                                        ].map((item, index) => (
                                            <Col key={index} xs={12} sm={4} md={4} lg={3}>
                                                <div className="h-100 text-center product_item">
                                                    <Card.Img variant="top" src={item.ImgUrl} alt={item.name} />
                                                    <Card.Body>
                                                        <Card.Title>{item.name}</Card.Title>
                                                        <p>{item.desc}</p>
                                                        <Button
                                                            variant="outline"
                                                            size="sm"
                                                            as={Link}
                                                            to="/watches-list/Frederique%20Constant"
                                                        >
                                                            Explore Now
                                                        </Button>
                                                    </Card.Body>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                )

                            }

                        </Col>
                    </Row>
                </Container >
            </section>

            <section className='fred_section3'>
                <Container className="watch_container2">
                    <Row className="align-items-center">
                        {/* Left Image */}
                        <Col lg={6} xs={12} className="mb-4 mb-md-0">
                            <img
                                src={WatchImg}
                                alt="Watch"
                                className="img-fluid "
                            />
                        </Col>

                        {/* Right Text */}
                        <Col lg={6} xs={12}>
                            <div className='fred_des_text'>
                                <h3 className="fw-bold">YOUR DESTINATION FOR FRÉDÉRIQUE
                                    CONSTANT TIMEPIECES</h3>
                                <p>
                                    Experience Swiss watchmaking excellence with Frédérique Constant.
                                    Our collection blends timeless elegance with modern innovation,
                                    offering luxury timepieces crafted for every occasion.
                                </p>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='hamilt_end_banner'>
                <div className='hamilt_end_banner_img'>
                    <Link to="/watches/Frederique%20Constant"> <img src={HamiBanner} alt="ham-banner" /> </Link>
                </div>
            </section>
        </>
    )
}

export default FrederiqueConstant